import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetEventQuery } from '../../../../../../redux/services/fo_events.jsx';
import { Spinner } from '../../../../../common/index.jsx';
import EventsDetail from '../../../../../common/FriOpen/Events/EventsDetail.jsx';
import { AppBarCMS } from '../../../../../basic/index.jsx';

const FoFoEventsDetailPage = () => {
  const { t } = useTranslation();
  const { eventId } = useParams();

  const { data: event, isLoading: isLoadingEvent } = useGetEventQuery(eventId);

  return isLoadingEvent ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('FRI Akcia')}
        backUrl={-1}
        backUrlTooltip={t('Späť')}
      />
      <div style={{ margin: '10px' }}>
        <EventsDetail event={event} />
      </div>
    </>
  );
};

export default FoFoEventsDetailPage;
